import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListMieiLaboratoriDTO } from '../../../model/newModel';
import { ConstantsCLA } from '../../../shared/constants-cla';
import { GetCommand } from 'src/app/model/command-model';

@Injectable({
  providedIn: 'root',
})
export class DashboardTutorService {
  constructor(private http: HttpClient) {}

  getMieiLaboratori(idTutor: number) {
    const command = new GetCommand();
    command.id = idTutor;
    return this.http.post<ListMieiLaboratoriDTO>(
      ConstantsCLA.I_MIEI_LABORATORI_URL,
      command
    );
  }
}
